import React from "react";
import {useTranslation} from "react-i18next"
import {IonItem, IonLabel, IonList} from "@ionic/react"

import LockTimeLimit from "@customTypes/LockTimeLimit"
import TimeLimit from "../../types/TimeLimit"

import IconLock from "../common/Icons/Lock"
import ItemSegmentListHeader from "../common/Headers/ItemSegmentListHeader"

interface componentProps {
    item:  TimeLimit | undefined;
}

const LocksList: React.FC<componentProps> = ({ item }) => {

    const {t} = useTranslation()

    const title: string    = item?.name || ''
    const subTitle: string = item?.description ? item?.description : ''

    return (
        <IonList lines="full" className="maxWidth">
            <ItemSegmentListHeader title={title} subTitle={subTitle} />

            {item?.lockTimeLimits === undefined || item.lockTimeLimits.length === 0 ? (
                <IonItem className="ion-text-center">
                    <IonLabel className="ion-text-wrap">
                        {t('time-limits.no_locks_for_time_limit')}
                    </IonLabel>
                </IonItem>
            ) : (
                item?.lockTimeLimits.map( (lockTimeLimit: LockTimeLimit) => {

                    return (
                        <IonItem button
                                 detail={true}
                                 key={'lock-' + lockTimeLimit.lock?.id}
                                 lines="inset"
                                 routerLink={'/locks/' + lockTimeLimit.lock?.id + '/view'}
                        >
                            <IconLock slot="start" />
                            <IonLabel>
                                <h2>
                                    {lockTimeLimit.lock?.lockingObject}
                                    {lockTimeLimit.lock?.serial &&
                                        <span style={{ 'fontWeight': '200', 'fontSize': '14px' }}>
                                        &nbsp;- {lockTimeLimit.lock?.serial}
                                    </span>
                                    }
                                </h2>
                                <h3 style={{ 'color': "#777" }}>
                                    {lockTimeLimit.lock?.lockType?.lockingSystemType?.brand?.name}
                                    - {lockTimeLimit.lock?.lockType?.name}
                                </h3>
                            </IonLabel>
                        </IonItem>
                    )
                })
            )}
        </IonList>
    )
}

export default LocksList